import { Vue, Component, Prop } from "vue-property-decorator";
import { time } from '@/utils/time';

@Component
export default class extends Vue {
  @Prop({ default: 1000 })
  wait!: number

  press = false
  done = false

  mounted() {
    this.press = true
  }

  async afterEnter() {
    await time.sleep(this.wait)
    this.press = false
  }

  afterLeave() {
    this.$emit('done')
  }
}
